import styled, { AnyStyledComponent } from 'styled-components';

export interface WrapperProps {
    sizeStyle: string;
    fill: string;
}

// Returns a wrapper for the SVG
export const IconWrapper: AnyStyledComponent = styled.svg`
    pointer-events: none;
    width: ${ ({ sizeStyle }: WrapperProps) => sizeStyle };
    height: ${ ({ sizeStyle }: WrapperProps) => sizeStyle };
    display: inline-block;
    overflow: visible;
    path {
        fill: ${ ({ fill }: WrapperProps) => fill };
    }
    rect {
        fill: ${ ({ fill }: WrapperProps) => fill };
        stroke: ${ ({ fill }: WrapperProps) => fill };
    }
    fill: ${ ({ fill }: WrapperProps) => fill };
    stroke ${ ({ fill }: WrapperProps) => fill };
`;
